import styles from '../css/HorizontalMenu.module.scss';
import updateLabel from './updateLabel';
import updateHorizontalLines from './updateHorizontalLines';

const activateNewRelease = (menuItems) => {
    const { catalog, newRelease, popular } = menuItems;
    const others = { first: catalog, second: popular };
    newRelease.classList.add(styles.horizontal__menu__container__display);
    updateHorizontalLines(others);
    return updateLabel(newRelease, others);
};

export default activateNewRelease;
